import React from 'react';

import { tv, type VariantProps } from 'tailwind-variants';

import cn from '../../../utils/cn';

const dropdownMenuIconVariants = tv({
  base: 'mr-1 flex  flex-row items-center justify-center  transition-all duration-500 ease-in-out',
  variants: {
    type: {
      contained: 'rounded-md bg-gray-lightest group-hover:bg-gray-light',
      ghost: '',
    },
  },
  defaultVariants: {
    type: 'ghost',
  },
});

type MenuIconsVariants = VariantProps<typeof dropdownMenuIconVariants>;

export interface DropdownMenuIconProps extends MenuIconsVariants {
  icon?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}

const DropdownMenuIcon = ({ icon, type, className }: DropdownMenuIconProps) => {
  const customIcon = React.cloneElement(icon as React.ReactElement, {
    className: cn('text-gray-dark', className),
    style: { width: '1rem', height: '1rem' },
  });

  return <div className={cn(dropdownMenuIconVariants({ type }), className)}>{customIcon}</div>;
};

export default DropdownMenuIcon;
